import * as types from '../constants/actionTypes';

// example of a thunk using the redux-thunk middleware
export function loadFeedbacks(settings) {
  return function (dispatch) {
    return dispatch({
      type: types.FEEDBACKS_LOADING,
      feedbacks: {
        page: settings.page,
        paging: settings.paging,
        sortBy: settings.sortBy,
        sortDirection: settings.sortDirection,
        filter: settings.filter,
        categories: settings.categories,
        dateFrom: settings.dateFrom,
        dateTo: settings.dateTo,
        withComment: settings.withComment,
        withReaction: settings.withReaction,
        rating: settings.rating,
        country: settings.country,
        createdBySkodaEmployee: settings.createdBySkodaEmployee,
      }
    });
  };
}

export function loadCategories() {
  return function (dispatch) {
    return dispatch({
      type: types.CATEGORIES_LOADING,
    });
  };
}

export function downloadFeedbacks(settings) {
  return function (dispatch) {
    return dispatch({
      type: types.FEEDBACKS_EXPORT_LOADING,
      feedbacks: {
        type: settings.type,
        sortBy: settings.sortBy,
        sortDirection: settings.sortDirection,
        filter: settings.filter,
        categories: settings.categories,
        dateFrom: settings.dateFrom,
        dateTo: settings.dateTo,
        withComment: settings.withComment,
        withReaction: settings.withReaction,
        rating: settings.rating,
        country: settings.country,
        createdBySkodaEmployee: settings.createdBySkodaEmployee,
      }
    });
  };
}

export function downloadFeedbacksAttachment(attachment) {
  return function (dispatch) {
    return dispatch({
      type: types.FEEDBACKS_ATTACHMENT_LOADING,
      attachment: attachment,
    });
  };
}

export function resetFile() {
  return function (dispatch) {
    return dispatch({
      type: types.FEEDBACKS_EXPORT_RESET,
    });
  };
}

export function sendToCask(feedbackId) {
  return function (dispatch) {
    return dispatch({
      type: types.FEEDBACK_SEND_REQUEST,
      feedback: {
        id: feedbackId,
      }
    });
  };
}

export function saveReaction(feedbackId, reaction) {
  return function (dispatch) {
    return dispatch({
      type: types.REACTION_SAVE_REQUEST,
      reaction: {
        id: feedbackId,
        value: reaction,
      }
    });
  };
}

export function deleteReaction(feedbackId) {
  return function (dispatch) {
    return dispatch({
      type: types.REACTION_DELETE_REQUEST,
      reaction: {
        id: feedbackId,
      }
    });
  };
}

export function deleteFeedback(feedbackId) {
  return function (dispatch) {
    return dispatch({
      type: types.FEEDBACK_DELETE_REQUEST,
      feedback: {
        id: feedbackId,
      }
    });
  };
}

export function updateCategory(feedbackId, value) {
  return function (dispatch) {
    return dispatch({
      type: types.CHANGE_CATEGORY_REQUEST,
      category: {
        id: feedbackId,
        value: value,
      }
    });
  };
}
